import Axios from "@/plugins/Axios";

export class NotificacaoPreferenciasService {
  async listar() {
    const response = await Axios().get("notificacoes-preferencias");
    return response.data;
  }

  async salvar(preferencias) {
    const response = await Axios().put("notificacoes-preferencias", { preferencias });
    return response.data;
  }
}

export default new NotificacaoPreferenciasService();
